import { render } from "./card-details.vue?vue&type=template&id=6e6d1d4c&scoped=true"
import script from "./card-details.vue?vue&type=script&lang=js"
export * from "./card-details.vue?vue&type=script&lang=js"

import "./card-details.vue?vue&type=style&index=0&id=6e6d1d4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6d1d4c"]])

export default __exports__